// Landing pages (components/hub). Neutral Latin American Spanish, Brazilian
// Portuguese; wording follows what people search (config/localeHubs.ts).
export const hub = {
  en: {
    "hub.views.count": "10 billion+",
    "hub.views.on": "views on",
    "hub.badge.covers": "10M+ covers made",
    "hub.badge.quality": "Studio-quality output",
    "hub.badge.youtube": "As seen on YouTube",
    "hub.trending": "Trending",
    "hub.popular": "Popular voices right now",
    "hub.browseAll": "Browse all",
    "hub.byCategory": "Browse voices by category",
    "hub.aiVoices": "AI voices",
    "hub.howItWorks": "How it works",
    "hub.faq": "Frequently asked questions",
    "hub.keepExploring": "Keep exploring",
    "hub.moreWays": "More ways to create with Jammable.",
    "hub.home": "Home",

    "widget.title": "Pick a voice to start",
    "widget.search": "Search voices",
    "widget.clear": "Clear search",
    "widget.matching": 'Voices matching "{q}"',
    "widget.popular": "Popular right now",
    "widget.noMatch": "No voices match that search.",
    "widget.searchAny": "Search for any voice above.",
    "widget.coverWith": "Make a cover with {name}",
    "widget.start": "Start with any voice",
    "widget.rights":
      "Next you add your audio. Only upload audio you have the rights to use.",

    // Shown in the language it offers, on pages that have a version in it.
    "lang.viewThisPage": "View this page in English",
    "lang.dismiss": "Dismiss",
  },
  es: {
    "hub.views.count": "Más de 10 mil millones",
    "hub.views.on": "de vistas en",
    "hub.badge.covers": "Más de 10 M de covers",
    "hub.badge.quality": "Calidad de estudio",
    "hub.badge.youtube": "Visto en YouTube",
    "hub.trending": "Tendencia",
    "hub.popular": "Voces populares ahora",
    "hub.browseAll": "Ver todas",
    "hub.byCategory": "Explora voces por categoría",
    "hub.aiVoices": "Voces IA",
    "hub.howItWorks": "Cómo funciona",
    "hub.faq": "Preguntas frecuentes",
    "hub.keepExploring": "Sigue explorando",
    "hub.moreWays": "Más formas de crear con Jammable.",
    "hub.home": "Inicio",

    "widget.title": "Elige una voz para empezar",
    "widget.search": "Buscar voces",
    "widget.clear": "Borrar búsqueda",
    "widget.matching": 'Voces que coinciden con "{q}"',
    "widget.popular": "Populares ahora",
    "widget.noMatch": "Ninguna voz coincide con tu búsqueda.",
    "widget.searchAny": "Busca cualquier voz arriba.",
    "widget.coverWith": "Hacer un cover con {name}",
    "widget.start": "Empezar con cualquier voz",
    "widget.rights":
      "Después agregas tu audio. Sube solo audio que tengas derecho a usar.",

    "lang.viewThisPage": "Ver esta página en español",
    "lang.dismiss": "Cerrar",
  },
  pt: {
    "hub.views.count": "Mais de 10 bilhões",
    "hub.views.on": "de visualizações no",
    "hub.badge.covers": "Mais de 10 mi de covers",
    "hub.badge.quality": "Qualidade de estúdio",
    "hub.badge.youtube": "Visto no YouTube",
    "hub.trending": "Em alta",
    "hub.popular": "Vozes populares agora",
    "hub.browseAll": "Ver todas",
    "hub.byCategory": "Explore vozes por categoria",
    "hub.aiVoices": "Vozes de IA",
    "hub.howItWorks": "Como funciona",
    "hub.faq": "Perguntas frequentes",
    "hub.keepExploring": "Continue explorando",
    "hub.moreWays": "Mais jeitos de criar com o Jammable.",
    "hub.home": "Início",

    "widget.title": "Escolha uma voz para começar",
    "widget.search": "Buscar vozes",
    "widget.clear": "Limpar busca",
    "widget.matching": 'Vozes com "{q}"',
    "widget.popular": "Populares agora",
    "widget.noMatch": "Nenhuma voz encontrada.",
    "widget.searchAny": "Busque qualquer voz acima.",
    "widget.coverWith": "Fazer um cover com {name}",
    "widget.start": "Começar com qualquer voz",
    "widget.rights":
      "Depois você adiciona seu áudio. Envie só áudio que você tem direito de usar.",

    "lang.viewThisPage": "Ver esta página em português",
    "lang.dismiss": "Fechar",
  },
};
